import fetch from '@/plugin/axios'
// 成长协议列表
export function getList (query) {
  return fetch({
    url: '/api/order/growing-agreement/list',
    method: 'Post',
    data: query
  })
}
// 新增成长协议
export function getAdd (query) {
  return fetch({
    url: '/api/order/growing-agreement/add',
    method: 'Post',
    data: query
  })
}
// 详情
export function getInfo (id) {
  return fetch({
    url: `/api/order/growing-agreement/info/${id}`,
    method: 'Get'
  })
}
// 修改
export function getEidt (id, query) {
  return fetch({
    url: `/api/order/growing-agreement/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 关闭活动
export function getClose (id) {
  return fetch({
    url: `/api/order/growing-agreement/close/${id}`,
    method: 'Get'
  })
}
// 开启活动
export function getOpen (id) {
  return fetch({
    url: `/api/order/growing-agreement/open/${id}`,
    method: 'Get'
  })
}
